/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type PostAIConfigVariationsBulkPathParams = NonNullable<
  operations['postAIConfigVariationsBulk']['parameters']['path']
>;

export type PostAIConfigVariationsBulkRequestBody = OperationRequestBodyContent<
  operations['postAIConfigVariationsBulk']
>;

export interface Input extends PostAIConfigVariationsBulkPathParams {
  apiVersion?: string;
  body: PostAIConfigVariationsBulkRequestBody;
}

export async function postAIConfigVariationsBulk(
  { apiVersion, body, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().POST('/internal/projects/{projectKey}/ai-configs/{configKey}/variationsBulk', {
    params: { path },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
